module.exports = __webpack_public_path__ + "img/cart-icon-audio.6028fd29.svg";